import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../conf.service';
import {MatSnackBar} from '@angular/material';
import {environment} from '../../environments/environment';
import * as CryptoJS from 'crypto-js';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
    hide = true;
    confirmHide = true;
    confirmPassword: string;
    password: string;
    validation = false;
    passwordCheck = false;
    validationMesaage: string;
    errorMessage: string;
    content: boolean;
    email: string;
    token: string;
    navigate: boolean;
    success: boolean;

    containsDigit = false;
    containsLowerCase = false;
    containsUpperCase = false;
    containsSpecialCharacter = false;
    environmentsString: any;

    constructor(private confPost: ConfService, private Urlroute: ActivatedRoute, public platform: LeftpanelComponent,
    private router: Router ) { }

  ngOnInit() {

      this.Urlroute.queryParams
          .subscribe(params => {
              if (params.emailId && params.token) {
                  this.token = params.token;
                  this.environmentsString = params.environments;
                  this.confPost.verifyResetToken(params.emailId, params.token, params.environments).subscribe(data => {
                      if (data.status === 200) {
                          this.email = params.emailId;
                          this.content = true;
                      } else if (data.status === 208) {
                          this.errorMessage = 'Token is invalid. Please sign up to continue';
                      }
                  }, error => {
                      this.content = false;
                      this.errorMessage = error.error.message;
                  });
              }
          });
      this.confPost.getData('services', 'services', 'v1', 'settings', '')
  }

    passwordPolicyValidator() {
        return new Promise((resolve, reject) => {
            let i = 0;
            let character = '';
            if (this.password.length < 8) {
                resolve(false);
            } else {
                while (i <= this.password.length) {
                    character = this.password.charAt(i);
                    if (character.charCodeAt(0) >= 48 && character.charCodeAt(0) <= 57) {
                        this.containsDigit = true;
                    }
                    if (character.charCodeAt(0) >= 65 && character.charCodeAt(0) <= 90) {
                        this.containsUpperCase = true;
                    }
                    if (character.charCodeAt(0) >= 97 && character.charCodeAt(0) <= 122) {
                        this.containsLowerCase = true;
                    }
                    if (character.charCodeAt(0) >= 32 && character.charCodeAt(0) <= 47 ||
                        character.charCodeAt(0) >= 58 && character.charCodeAt(0) <= 64 ||
                        character.charCodeAt(0) >= 91 && character.charCodeAt(0) <= 96 ||
                        character.charCodeAt(0) >= 123 && character.charCodeAt(0) <= 126) {
                        this.containsSpecialCharacter = true;
                    }
                    i++;
                    if (i === this.password.length) {
                        if (this.containsDigit && this.containsLowerCase && this.containsUpperCase && this.containsSpecialCharacter) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    }
                }
            }
        });
    }

    encrypt (salt, iv, passPhrase, plainText, keySize, iterationCount) {
        const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), { keySize: keySize, iterations: iterationCount });
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            key,
            { iv: CryptoJS.enc.Hex.parse(iv) });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    partnerValidation() {
        this.validationMesaage = '';
        this.validation = false;
        this.passwordCheck = false;
        if (this.password) {
            if (this.password === this.confirmPassword) {
                this.passwordPolicyValidator().then(response => {
                    if (response) {
                        this.passwordCheck = true;
                        if (this.passwordCheck) {
                            const iterationCount = 1000;
                            let keySize = 128;
                            keySize = keySize / 32;
                            const passphrase = environment.cipheringPhrase;

                            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                            const cipherText = this.encrypt(salt, iv, passphrase, this.password, keySize, iterationCount);
                            const resetPasswordPayload = {
                                emailId: this.email,
                                environmentsString: this.environmentsString,
                                password: cipherText,
                                shash: salt,
                                ralam: iv
                            };
                            this.confPost.passwordComplete(resetPasswordPayload).subscribe(data => {
                                this.platform.openSnackBar('Password has been reset successfully', 'Success', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.navigate = true;
                            }, error => {
                                this.platform.openSnackBar((error.text ? error .text : error.message), '', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            });
                        }
                    } else {
                        this.validationMesaage = 'Please make sure that your password follows our password policy';
                    }
                });
            } else {
                this.validationMesaage = 'Password Miss-Match.';
            }
        } else {
            this.validationMesaage = 'Password is Mandatory.';
        }
    }
    updatePassword() {
      this.partnerValidation();
    }
    navigateTODashboard() {
         this.router.navigate(['/auth/login']);
    }
}
